export enum ChapterState {
  Pending = "pending",
  Current = "current",
  Done = "done",
}
